<template>
    <v-container colum fluid fill-height>
        <v-row>
            <v-col cols=4 v-for="(box,idx) in list" :key="'box_'+box.id">
              <PendingBox v-model="list[idx]" @refresh="getPendingBoxes"/>
            </v-col>
        </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PendingBox from "./PendingBox.vue"
export default {
  components:{
    PendingBox
  },
  data: () => ({
    missingItemsDetail:{}
  }),
  computed:{
    ...mapGetters("pendingbox",["list"]),
  },
  mounted: function() {
    this.getPendingBoxes()
  },
  methods:{
    ...mapActions("pendingbox", {getPendingBoxes: 'list'})
  }
}
</script>

<style>

</style>